interface ActivityList {
    id: string;
    displayName: string;
    subCat: string[];
    img: string;
}

const activities: ActivityList[] = [
    {
        id: 'hiking',
        displayName: 'Hiking',
        subCat: ['Backpacking', 'Day hiking'],
        img: '/static/img/icons/activities/activity-backpacking.png',
    },
    {
        id: 'overland-camping',
        displayName: 'Overland/Offroad',
        subCat: ['Overland', 'Offroad', 'ATV', 'Motorcycle', 'Car Camping'],
        img: '/static/img/icons/activities/activity-overlanding-2x.png',
    },
    {
        id: 'backcountry-ski',
        displayName: 'Snow',
        subCat: ['Backcountry', 'Downhill', 'Cross Country', 'Snowmobile'],
        img: '/static/img/icons/activities/activity-skiing.png',
    },
    {
        id: 'biking',
        displayName: 'Biking',
        subCat: ['Mountain', 'Road'],
        img: '/static/img/icons/activities/activity-mountain-biking-2x.png',
    },
    {
        id: 'hunting',
        displayName: 'Hunting',
        subCat: ['Bow', 'Rifle'],
        img: '/static/img/icons/activities/activity-hunting.png',
    },
    {
        id: 'professional',
        displayName: 'Professional',
        subCat: ['SAR', 'Research', 'Firefighting', 'Military/Law', 'Logging'],
        img: '/static/img/icons/activities/professional-48px.png',
    },
    {
        id: 'fishing',
        displayName: 'Boating/Fishing',
        subCat: [
            'Canoe',
            'White Water',
            'Open Water',
            'Fly Fish',
            'Casting',
            'Fishing',
        ],
        img: '/static/img/icons/activities/activity-fishing-2x.png',
    },
];

export default activities;
